import type { FetchFn, Logger, InteractionsConfig } from '@wix/thunderbolt-becky-types'
import type { SpecMapBuilderComponent, ViewerClientSpecMap, BuilderComponentData } from '@wix/thunderbolt-symbols'

export const getBuilderComponentsInteractions = async (
	fetchFn: FetchFn,
	logger: Logger,
	clientSpecMap: ViewerClientSpecMap
): Promise<Record<BuilderComponentData['type'], InteractionsConfig>> => {
	const builderComponentsInteractions: Record<SpecMapBuilderComponent['type'], InteractionsConfig> = {}
	const fetchPromises: Array<Promise<void>> = []

	Object.values(clientSpecMap).forEach((appSpec) => {
		appSpec.components?.forEach((comp) => {
			const interactionsUrl = comp.data.resources.interactions?.url
			if (interactionsUrl) {
				const fetchPromise = fetchFn(interactionsUrl)
					.then((response) => {
						if (!response.ok) {
							throw new Error(`http error, status: ${response.status}, text: ${response.statusText}`)
						}
						return response.json()
					})
					.then((interactionsConfig: InteractionsConfig) => {
						builderComponentsInteractions[comp.data.type] = interactionsConfig
					})
					.catch((e) => logger.error(e))
				fetchPromises.push(fetchPromise)
			}
		})
	})

	await Promise.all(fetchPromises)
	return builderComponentsInteractions
}
